import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalThemMoiChiNgoaiLe } from "../../ThemMoi/ThemMoiChiNgoaiLe/ModalThemMoiChiNgoaiLe";

export const BtnSuaPhieuChiNgoaiLe = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a href={() => false} onClick={handleShow}>
        <PopoversBootrap
          contentText="Sửa"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
              <img src="/app-assets/images/icon-edit-v2.png" />
        </PopoversBootrap>
      </a>
      {show && (
        <ModalThemMoiChiNgoaiLe
          show={show}
          onHide={handleClose}
          thuchiId={item.ThuChiID}
        />
      )}
    </>
  );
};
